import { proxy, useSnapshot } from 'valtio';
interface PageReferrerState {
  pageReferrer: string;
  prevUrl: string;
}
export const pageReferrerStateActions = {
  setPageReferrer: (url: string) => {
    pageReferrerState.pageReferrer = url;
  },
  setPrevPageReferrer: (url: string) => {
    pageReferrerState.prevUrl = url;
  },
};

export const pageReferrerState = proxy<PageReferrerState>({
  pageReferrer: '',
  prevUrl: '',
});

export const usePageReferrerState = () => useSnapshot(pageReferrerState);
